import api from './axiosConfig';

const STORAGE_KEY_RATE = 'grotn_fx_rate';
const STORAGE_KEY_EXPIRY = 'grotn_fx_expiry';
const TTL_MS = 60 * 60 * 1000; // 1 hour

let memoryCache = { EUR_to_USD: null, cachedAt: 0 };

/**
 * Get EUR to USD rate. Uses sessionStorage + in-memory cache with TTL.
 * @returns {Promise<{ EUR_to_USD: number, cachedAt: number } | null>}
 */
export async function getFxRate() {
  const now = Date.now();

  if (memoryCache.EUR_to_USD != null && (now - memoryCache.cachedAt) < TTL_MS) {
    return { EUR_to_USD: memoryCache.EUR_to_USD, cachedAt: memoryCache.cachedAt };
  }

  try {
    const expiry = sessionStorage.getItem(STORAGE_KEY_EXPIRY);
    if (expiry && now < parseInt(expiry, 10)) {
      const raw = sessionStorage.getItem(STORAGE_KEY_RATE);
      if (raw) {
        const data = JSON.parse(raw);
        if (typeof data.EUR_to_USD === 'number' && Number.isFinite(data.EUR_to_USD)) {
          memoryCache = { EUR_to_USD: data.EUR_to_USD, cachedAt: data.cachedAt || now };
          return { EUR_to_USD: data.EUR_to_USD, cachedAt: memoryCache.cachedAt };
        }
      }
    }
  } catch (_) {
    // ignore parse/storage errors
  }

  try {
    const res = await api.get('/api/fx-rate');
    const EUR_to_USD = res.data?.EUR_to_USD;
    const cachedAt = res.data?.cachedAt || now;
    if (typeof EUR_to_USD === 'number' && Number.isFinite(EUR_to_USD) && EUR_to_USD > 0) {
      memoryCache = { EUR_to_USD, cachedAt };
      sessionStorage.setItem(STORAGE_KEY_RATE, JSON.stringify({ EUR_to_USD, cachedAt }));
      sessionStorage.setItem(STORAGE_KEY_EXPIRY, String(now + TTL_MS));
      return { EUR_to_USD, cachedAt };
    }
  } catch (err) {
    console.warn('[FX] getFxRate failed:', err?.message || err);
  }

  return memoryCache.EUR_to_USD != null
    ? { EUR_to_USD: memoryCache.EUR_to_USD, cachedAt: memoryCache.cachedAt }
    : null;
}
